export default __webpack_public_path__ + "images/fb9829b3531c190782e006bd54fd36c2-amazonpay-logo-yellow.svg";